
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/s/rewards",
      function () {
        return require("private-next-pages/cleartax.in/s/rewards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/s/rewards"])
      });
    }
  